import React, { PropsWithChildren, Ref } from 'react';
import * as ScrollArea from '@radix-ui/react-scroll-area';
import styles from './styles.module.css';

export type ScrollAreaContainerProps = PropsWithChildren<{
  orientacao: 'vertical' | 'horizontal';
  refScrollAreaViewport?: Ref<HTMLDivElement> | null | undefined;
  lidarScroll?: () => void;
}>;

export default function ScrollAreaContainer(props: ScrollAreaContainerProps) {
  const {
    orientacao,
    refScrollAreaViewport = undefined,
    lidarScroll = undefined,
  } = props;
  return (
    <ScrollArea.Root className={styles.container}>
      <ScrollArea.Viewport ref={refScrollAreaViewport} onScroll={lidarScroll}>
        {props.children}
      </ScrollArea.Viewport>
      <ScrollArea.Scrollbar orientation={orientacao}>
        <ScrollArea.Thumb />
      </ScrollArea.Scrollbar>
    </ScrollArea.Root>
  );
}
